
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'WatermarksFooter'
})
export default class WatermarksFooter extends Vue {
  get shouldShowNSPA() {
    return ['/about-us', '/register', '/register2', '/contact', '/my-account'].includes(window.document.location.pathname)
  }
}
